import axios from "../axiosClient";

export const getLocationSites = async (
  PageNumber: any,
  pageSize: any,
  SortBy: any,
  SortDirection: any,
  searchText: any,
  signal: any
) => {
  const res = await axios.get(`/slpapp/Site/getall`, {
    params: { PageNumber, pageSize, searchText, SortBy, SortDirection },
    signal,
  });

  return res?.data;
};

export const getSiteProjectCategories = async (signal: any) => {
  const res = await axios.get(`/slpapp/SiteProjectType`, {
    signal,
  });

  return res?.data;
};
